const Share = {};

export default Share;
